export default __webpack_public_path__ + "static/media/cycloneofsteel7.49bb95d0.png";